export const AboutSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16 animate-fade-in">
            <h3 className="text-4xl md:text-5xl font-bold text-primary mb-4">عن الجمعية</h3>
            <div className="w-24 h-1 bg-accent mx-auto"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Image */}
            <div className="relative animate-slide-up">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/4197bb027bbdf0b2defc27e718198212.jpg"
                  alt="فريق عيادة الإقلاع الطبي"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-accent/20 rounded-full blur-3xl"></div>
              <div className="absolute -top-6 -left-6 w-32 h-32 bg-primary/20 rounded-full blur-3xl"></div>
            </div>

            {/* Content */}
            <div className="space-y-8 animate-slide-up" style={{ animationDelay: '0.2s' }}>
              {/* Vision */}
              <div className="bg-gradient-to-br from-primary/5 to-secondary/5 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-eye-line text-white text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-2xl font-bold text-primary mb-3">رؤيتنا</h4>
                    <p className="text-gray-700 leading-relaxed">
                      <strong>مجتمع خالٍ من التدخين</strong> يتمتع بصحة أفضل وحياة أطول، حيث نسعى لتحقيق بيئة صحية خالية من أضرار التبغ
                    </p>
                  </div>
                </div>
              </div>

              {/* Mission */}
              <div className="bg-gradient-to-br from-secondary/5 to-accent/5 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-secondary rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-flag-line text-white text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-2xl font-bold text-secondary mb-3">رسالتنا</h4>
                    <p className="text-gray-700 leading-relaxed">
                      تقديم <strong>خدمات طبية متخصصة ومجانية</strong> لمساعدة المدخنين على الإقلاع عن التدخين من خلال برامج علاجية وتوعوية شاملة تشمل الدعم الطبي والنفسي والسلوكي
                    </p>
                  </div>
                </div>
              </div>

              {/* Values */}
              <div className="bg-gradient-to-br from-accent/5 to-primary/5 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-heart-line text-white text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-2xl font-bold text-accent mb-3">قيمنا</h4>
                    <p className="text-gray-700 leading-relaxed">
                      نلتزم بـ<strong>الاحترافية والخصوصية والرحمة</strong> في تقديم خدماتنا، مع التركيز على احتياجات كل مريض وتوفير بيئة آمنة وداعمة لرحلة الإقلاع
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};